import ImageSubCategoryList from './ImageSubCategoryList'

export default ImageSubCategoryList
